import { SearchOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import SelectActorType from "./Elements/Select-Actor-Type";
import SelectCities from "./Elements/Select-Cities";
import SelectCommercialActivityType from "./Elements/Select-Comercial-Activity";
import SelectRecognition from "./Elements/Select-Recognize";
import Search from "antd/es/input/Search";
import { useState } from "react";

interface Props {
  onSelectActorChange: (value: string) => void;
  onSearch: (value: string) => void;
  onSearchChangeValue: (value: string) => void;
  onSelectCommercialActivityTypeChange: (value: string) => void;
  onSelectRecognitionChange: (value: string) => void;
  onSelectCitiesChange: (value: any) => void;
  onSearchPressEnter: (value: any) => void;
  onClearActorType: () => void;
  onClearCity: () => void;
  onClearCommercialActivity: () => void;
  onClearMinCiencia: () => void;
}

const SearchEntityForm = (props: Props) => {
  const [hideCommercialActivity, setHiddenCommercialActivity] = useState(true);
  const ENTERPRISE_KEY = "entities";

  return (
    <>
      <Row gutter={[8, 8]} style={{ width: "100%" }}>
        <Col xs={24} sm={12} md={6} lg={10}>
          <SelectActorType
            onClear={() => {
              props.onClearActorType();
            }}
            style={{ width: "100%" }}
            size="large"
            defaultValue="Actor"
            onChange={(selected: any) => {
              props.onSelectActorChange(selected);

              if (selected.collectionName?.toLowerCase() === ENTERPRISE_KEY) {
                setHiddenCommercialActivity(false);
              } else {
                setHiddenCommercialActivity(true);
              }
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={14} className="align-items">
          <Search
            addonBefore={<SearchOutlined />}
            className="ant-input-shadow"
            placeholder="Escribe lo que buscas"
            allowClear
            onChange={(event) => {
              props.onSearchChangeValue(event.target.value);
            }}
            onPressEnter={($event: any) => {
              props.onSearchPressEnter($event.target.value);
            }}
            onSearch={(value: string) => {
              props.onSearch(value);
            }}
            style={{ borderRadius: 0 }}
            enterButton="Buscar"
            size="large"
          />
        </Col>
      </Row>
      <Row gutter={[8, 8]} style={{ width: "100%" }}>
        {hideCommercialActivity ? null : (
          <Col xs={24} sm={12} md={6} lg={8} className="align-items">
            <SelectCommercialActivityType
              placeholder="Activdad comercial"
              mode="undefined"
              style={{ width: "100%" }}
              size="large"
              defaultValue="Actividad económica"
              onChange={(value: string) => {
                props.onSelectCommercialActivityTypeChange(value);
              }}
              onClear={() => {
                props.onClearCommercialActivity();
              }}
            />
          </Col>
        )}
        <Col
          xs={24}
          sm={12}
          md={6}
          lg={hideCommercialActivity ? 12 : 8}
          className="align-items"
        >
          <SelectRecognition
            onClear={() => {
              props.onClearMinCiencia();
            }}
            style={{ width: "100%" }}
            size="large"
            defaultValue="Reconocido por Min. ciencia"
            onChange={(value: string) => {
              props.onSelectRecognitionChange(value);
            }}
          />
        </Col>
        <Col
          xs={24}
          sm={12}
          md={6}
          lg={hideCommercialActivity ? 12 : 8}
          className="align-items"
        >
          <SelectCities
            style={{ width: "100%" }}
            size="large"
            defaultValue="Ciudad"
            onChange={(selected: string) => {
              props.onSelectCitiesChange(selected);
            }}
            onClear={() => {
              props.onClearCity();
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default SearchEntityForm;
